// src/components/Contact.js
import React from 'react';
import { Parallax } from 'react-parallax';
import userImage1 from '../images/user1.1.jpg'; // Update with the correct path to the image
import userImage2 from '../images/user2.2.jpg'; // Update with the correct path to the image

const Contact = () => {
    return (
        <div className="relative min-h-screen">
            <Parallax bgImage="https://media.istockphoto.com/id/1144632027/photo/blue-motion-blur-abstract-background.webp?b=1&s=170667a&w=0&k=20&c=WkFyJkh10HZUjj1KqTUoI3gXHcUzDL7WILWPP1IODYg=" strength={100}>
                <div className="flex items-center justify-center pt-24 pb-8">
                    <div className="bg-white bg-opacity-70 shadow-lg rounded-lg p-6 sm:p-8 md:p-10 max-w-4xl mx-4 sm:mx-6 md:mx-8 lg:mx-auto">
                        <h2 className="text-3xl sm:text-4xl font-bold text-center text-green-900 mb-4 sm:mb-6">Contact Us</h2>
                        <p className="mt-4 text-base sm:text-lg text-gray-800 leading-relaxed text-center">
                            Get in touch with us to learn more about our initiatives and how you can get involved.
                        </p>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
                            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                                <div className="flex flex-col items-center p-6">
                                    <img src={userImage1} alt="Ajeet Jain" className="w-32 h-32 rounded-full object-cover mb-4" />
                                    <h3 className="text-2xl font-bold">Ajeet Jain</h3>
                                    <p className="mt-2 text-center">Promoter - EPTech</p>
                                    <p>M.E Chemical Engineering (UOR)</p>
                                    <p className="mt-2 text-center">Email: ajeet_jain@yahoo.com</p>
                                    <p className="mt-2 text-center">Phone: (+91) 7018704140</p>
                                </div>
                            </div>

                            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                                <div className="flex flex-col items-center p-6">
                                    <img src={userImage2} alt="Aryan Jain" className="w-32 h-32 rounded-full object-cover mb-4" />
                                    <h3 className="text-2xl font-bold">Aryan Jain</h3>
                                    <p className="mt-2 text-center">Tech Developer</p>
                                    <p>B.Tech CSE (VIT)</p>
                                    <p className="mt-2 text-center">Email: 22aj.aryan@gmail.com</p>
                                    <p className="mt-2 text-center">Phone: (+91) 9816443545</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Parallax>
        </div>
    );
};

export default Contact;